export default "__VITE_PUBLIC_ASSET__03bed746__"